// Get Inventory & Products Analytics Use Case

import type {HomeAnalyticsRepository} from '../repository/HomeAnalyticsRepository';
import type {InventoryProductsAnalytics} from '../models/homeAnalytics.model';

export class GetInventoryProductsAnalyticsUseCase {
  constructor (private repository: HomeAnalyticsRepository) {}

  async execute (): Promise<InventoryProductsAnalytics> {
    return this.repository.getInventoryProductsAnalytics();
  }
}
